import React from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ProblemSection } from './components/ProblemSection';
import { SuccessStories } from './components/SuccessStories';
import { ProjectCarousel } from './components/ProjectCarousel';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusGrid } from './components/BonusGrid';
import { ImpactShowcase } from './components/ImpactShowcase';
import { AntiScamSection } from './components/AntiScamSection';
import { PriceBox } from './components/PriceBox';
import { VideoMockupSection } from './components/VideoMockupSection';
import { FAQSection } from './components/FAQSection';
import { CommentsSection } from './components/CommentsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-transparent font-sans selection:bg-[#ec4899]/30 selection:text-white text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBanner data-id="element-2" />

      <main className="flex flex-col" data-id="element-3">
        <HeroSection data-id="element-4" />
        <ComparisonTable data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <SuccessStories data-id="element-7" />
        <ProjectCarousel data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <BonusGrid data-id="element-10" />
        <ImpactShowcase data-id="element-11" />
        <AntiScamSection data-id="element-12" />
        <PriceBox data-id="element-13" />
        <VideoMockupSection data-id="element-14" />
        <CommentsSection data-id="element-15" />
        <TestimonialsSection data-id="element-16" />
        <FAQSection data-id="element-17" />
      </main>

      <footer className="bg-transparent py-12 border-t border-[#27272a] text-center" role="contentinfo" data-id="element-18">
        <div className="max-w-7xl mx-auto px-4" data-id="element-19">
          <p className="text-gray-400 text-sm mb-2" data-id="element-20">
            © 2026 Neon Flex Academy. Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-sm mb-4" data-id="element-21">
            Soporte:{' '}
            <a href="mailto:soportesinfinstudio@gmail.com" className="hover:text-white transition-colors" data-id="element-22">
              soportesinfinstudio@gmail.com
            </a>
          </p>
          <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-23">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}